import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LobbiesGetQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
  language: Types.Scalars['String']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type LobbiesGetQuery = { __typename?: 'Query', lobbies: Array<{ __typename?: 'lobbies', icon?: string | null, internal_name?: string | null, show_categories?: boolean | null, translations?: Array<{ __typename?: 'lobbies_translations', description?: string | null, slug?: string | null } | null> | null, banner_collection?: { __typename?: 'banner_collection', internal_name?: string | null, static_banner?: { __typename?: 'static_banners', internal_name?: string | null, thumbnail?: { __typename?: 'directus_files', filename_disk?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, translations?: Array<{ __typename?: 'static_banners_translations', tag?: string | null, link_URL?: string | null, open_in_new_tab?: boolean | null } | null> | null } | null, banners?: Array<{ __typename?: 'banner_collection_banners', banners_id?: { __typename?: 'banners', internal_name?: string | null, translations?: Array<{ __typename?: 'banners_translations', title?: string | null, subtitle?: string | null, sub_content?: string | null, link_text?: string | null, link_URL?: string | null, open_in_new_tab?: boolean | null } | null> | null, mobile_image?: { __typename?: 'directus_files', width?: number | null, height?: number | null, filename_disk?: string | null, title?: string | null } | null, desktop_image?: { __typename?: 'directus_files', width?: number | null, height?: number | null, filename_disk?: string | null, title?: string | null } | null } | null } | null> | null } | null, categories?: Array<{ __typename?: 'lobbies_categories', categories_id?: { __typename?: 'categories', internal_name?: string | null, icon?: string | null, carousel_type?: string | null, translations?: Array<{ __typename?: 'categories_translations', title?: string | null, description?: string | null, slug?: string | null } | null> | null, games?: Array<{ __typename?: 'categories_game', game_id?: { __typename?: 'game', game_id?: string | null, translations?: Array<{ __typename?: 'game_translations', display_name?: string | null, slug?: string | null } | null> | null, game_image?: { __typename?: 'directus_files', filename_disk?: string | null, width?: number | null, height?: number | null } | null, game_image_box?: { __typename?: 'directus_files', filename_disk?: string | null, width?: number | null, height?: number | null } | null, game_image_tall?: { __typename?: 'directus_files', filename_disk?: string | null, width?: number | null, height?: number | null } | null, tags?: Array<{ __typename?: 'game_game_tags', game_tags_id?: { __typename?: 'game_tags', translations?: Array<{ __typename?: 'game_tags_translations', name?: string | null } | null> | null } | null } | null> | null } | null } | null> | null } | null } | null> | null }> };


export const LobbiesGetDocument = gql`
    query LobbiesGet($slug: String!, $language: String!, $limit: Int = 2500) {
  lobbies(
    filter: {translations: {slug: {_eq: $slug}, languages_language_code: {language_code: {_eq: $language}}}}
  ) {
    icon
    internal_name
    show_categories
    translations(
      filter: {languages_language_code: {language_code: {_eq: $language}}}
    ) {
      description
      slug
    }
    banner_collection(filter: {status: {_eq: "published"}}) {
      internal_name
      static_banner(filter: {status: {_eq: "published"}}) {
        internal_name
        thumbnail(filter: null) {
          filename_disk
          width
          height
          title
        }
        translations(
          filter: {languages_language_code: {language_code: {_eq: $language}}}
        ) {
          tag
          link_URL
          open_in_new_tab
        }
      }
      banners {
        banners_id(filter: {status: {_eq: "published"}}) {
          internal_name
          translations(
            filter: {languages_language_code: {language_code: {_eq: $language}}}
          ) {
            title
            subtitle
            sub_content
            link_text
            link_URL
            open_in_new_tab
          }
          mobile_image {
            width
            height
            filename_disk
            title
          }
          desktop_image {
            width
            height
            filename_disk
            title
          }
        }
      }
    }
    categories(filter: null) {
      categories_id {
        internal_name
        icon
        carousel_type
        translations(
          filter: {languages_language_code: {language_code: {_eq: $language}}}
        ) {
          title
          description
          slug
        }
        games(limit: $limit) {
          game_id(
            filter: {status: {_eq: "published"}, game_id: {_null: false, _empty: false}}
          ) {
            game_id
            translations(
              filter: {languages_language_code: {language_code: {_eq: $language}}}
            ) {
              display_name
              slug
            }
            game_image(filter: null) {
              filename_disk
              width
              height
            }
            game_image_box(filter: null) {
              filename_disk
              width
              height
            }
            game_image_tall(filter: null) {
              filename_disk
              width
              height
            }
            tags {
              game_tags_id(filter: null) {
                translations(
                  filter: {languages_language_code: {language_code: {_eq: $language}}}
                ) {
                  name
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLobbiesGetQuery__
 *
 * To run a query within a React component, call `useLobbiesGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useLobbiesGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLobbiesGetQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      language: // value for 'language'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useLobbiesGetQuery(baseOptions: Apollo.QueryHookOptions<LobbiesGetQuery, LobbiesGetQueryVariables> & ({ variables: LobbiesGetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LobbiesGetQuery, LobbiesGetQueryVariables>(LobbiesGetDocument, options);
      }
export function useLobbiesGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LobbiesGetQuery, LobbiesGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LobbiesGetQuery, LobbiesGetQueryVariables>(LobbiesGetDocument, options);
        }
export function useLobbiesGetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LobbiesGetQuery, LobbiesGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LobbiesGetQuery, LobbiesGetQueryVariables>(LobbiesGetDocument, options);
        }
export type LobbiesGetQueryHookResult = ReturnType<typeof useLobbiesGetQuery>;
export type LobbiesGetLazyQueryHookResult = ReturnType<typeof useLobbiesGetLazyQuery>;
export type LobbiesGetSuspenseQueryHookResult = ReturnType<typeof useLobbiesGetSuspenseQuery>;
export type LobbiesGetQueryResult = Apollo.QueryResult<LobbiesGetQuery, LobbiesGetQueryVariables>;